import type { RoleDefinition } from "@xop/dashboard-shared";

/**
 * The role card's subheader copy — protected vs customised vs baseline.
 * Extracted from `RolesPanel.tsx` as a pure function so the three branches
 * (and the customised "by X on Y" attribution) unit-test directly.
 */
export function roleSubheader(role: RoleDefinition): string {
  if (role.protected) {
    return "Always grants every permission. Edit other roles instead.";
  }
  if (role.customized) {
    const by = role.updated_by_email ? ` by ${role.updated_by_email}` : "";
    const on = role.updated_at ? ` on ${new Date(role.updated_at).toLocaleString()}` : "";
    return `Customised${by}${on}. Resetting restores the shipped bundle.`;
  }
  return "Using the shipped baseline. Tick or untick anything below to customise.";
}
